/**
 * Custom function that find template DX objects by one key
 *
 * @param {object} content The all object.
 * @param {string} keyToFind The key to find in the object.
 */
export const findTemplatesDxByKey = (content: any, keyToFind: string): any => {
  const templates: any[] = [];
  content.forEach((templateDx: any, _idx) => {
    if (keyToFind in templateDx) {
      templates.push(templateDx);
    }
  });
  return templates.length ? templates : null;
};

/**
 * Custom function that checks if a key exists or is not null or empty
 *
 * @param {object} content The object to check in.
 * @param {string} keyToCheck The key to check.
 */
export const checkIfKeyExists = (content: any, keyToCheck: string): any => {
  if (keyToCheck in content) {
    if (keyToCheck !== null || keyToCheck !== undefined || keyToCheck !== "") {
      return true;
    }
  } else {
    return false;
  }
};

/**
 * Custom function that checks if element is valid between 2 dates
 *
 * @param {object} item The item to check in.
 */
// export const isValidDate = (item: Record<any, any>): boolean => {
//   const sDateStart = item?.dateStart;
//   const sDateEnd = item?.dateEnd;
//   if (sDateStart || sDateEnd) {
//     const dateStart = Date.parse(sDateStart);
//     const dateEnd = Date.parse(sDateEnd);
//     const now = Date.now();
//     if (dateStart && !dateEnd) {
//       return now >= dateStart;
//     } else if (!dateStart && dateEnd) {
//       return now <= dateEnd;
//     } else if (dateStart && dateEnd) {
//       return now >= dateStart && now <= dateEnd;
//     } else {
//       return false;
//     }
//   } else {
//     return false;
//   }
// };

// utils/simulatedDate.ts

/**
 * Validate YYYY-MM-DD format strictly
 */
export const isValidDateFormat = (dateStr: string): boolean => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return false;

  const date = new Date(dateStr);
  return !isNaN(date.getTime());
};

/**
 * Get simulated date from URL or fallback to real date
 */
export const getCurrentDate = (): number => {
  if (typeof window === "undefined") {
    return Date.now(); // SSR safety
  }

  const params = new URLSearchParams(window.location.search);
  const simulatedDate = params.get("simulatedDate");

  if (!simulatedDate) {
    return Date.now();
  }

  if (!isValidDateFormat(simulatedDate)) {
    console.error(`[SimulatedDate] Invalid format: ${simulatedDate}`);
    return Date.now();
  }

  const parsed = Date.parse(simulatedDate);

  if (isNaN(parsed)) {
    console.error(`[SimulatedDate] Invalid date: ${simulatedDate}`);
    return Date.now();
  }

  return parsed;
};

/**
 * Check if two dates are the same day (ignoring time)
 */
export const isSameDay = (date1: number, date2: number): boolean => {
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
};

/**
 * Main util replacing isValidDate
 */
export const isValidDate = (item: Record<string, any>): boolean => {
  const sDateStart = item?.dateStart;
  const sDateEnd = item?.dateEnd;

  if (!sDateStart && !sDateEnd) {
    return false;
  }

  const now = getCurrentDate();

  const dateStart = sDateStart ? Date.parse(sDateStart) : null;
  const dateEnd = sDateEnd ? Date.parse(sDateEnd) : null;

  // Special rule: show content if simulated date === start date
  if (dateStart && isSameDay(now, dateStart)) {
    return true;
  }

  if (dateStart && !dateEnd) {
    return now >= dateStart;
  }

  if (!dateStart && dateEnd) {
    return now <= dateEnd;
  }

  if (dateStart && dateEnd) {
    return now >= dateStart && now <= dateEnd;
  }

  return false;
};
